import { Collection } from 'modules/core/lib/mobx-rest'

import Score from 'modules/documents/store/models/Score'

class Scores extends Collection<Score> {
  get cacheKey(): string {
    return 'scores'
  }

  model() {
    return Score
  }
}

const scores: Scores = new Scores()

export default scores
